import * as Icons from "react-bootstrap-icons";
import HomeData from "Screens/Admin/Components/Home/HomeData";
import SocialData from "Screens/Admin/Components/Social/SocialData";
import TamimaData from "Screens/Admin/Components/Tamima/TamimaData";
import CharactersData from "Screens/Admin/Components/Characters/CharactersData";
import BlogsData from "Screens/Admin/Components/Blogs/BlogsData";
import WhitepaperData from "Screens/Admin/Components/WhitePaper/WhitepaperData";
import RoadmapData from "Screens/Admin/Components/Roadmap/RoadmapData";

export const ManagerMenuItems = [
  {
    title: "Home page",
    icon: <Icons.House />,
    value: "home",
    bodyContainer: <HomeData />,
  },
  {
    title: "Roadmap",
    icon: <Icons.Map />,
    value: "roadmap",
    bodyContainer: <RoadmapData />,
  },
  {
    title: "Whitepaper",
    icon: <Icons.FileText />,
    value: "whitepaper",
    bodyContainer: <WhitepaperData />,
  },
  {
    title: "Tamima page",
    icon: <Icons.Person />,
    value: "tamima",
    bodyContainer: <TamimaData />,
  },
  {
    title: "Characters",
    icon: <Icons.Easel2 />,
    value: "character",
    bodyContainer: <CharactersData />,
  },
  {
    title: "Blogs",
    icon: <Icons.Postcard />,
    value: "blog",
    bodyContainer: <BlogsData />,
  },
  {
    title: "Social page",
    icon: <Icons.Threads />,
    value: "social",
    bodyContainer: <SocialData />,
  },
];
